"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGeoPushpinWidgetStyle = exports.isFullWidthGeoPushpin = exports.isGeoPushpin = exports.calculateGeoPushpinWidgetHeight = void 0;
var constants_1 = require("../../../components/pluggableVisualizations/constants");
var constants_2 = require("../../DashboardLayout/constants");
var RATIO_16_9 = 9 / 16;
var HEADER_HEIGHT = 330;
var PADDING_BOTTOM = 55;
var HEADLINE_OUTER_HEIGHT = 48 + 20; // item-headline-outer + padding-top/bottom
function calculateGeoPushpinWidgetHeight(windowHeight, visualizationItemWidth) {
    var widgetHeight = Math.round(visualizationItemWidth * RATIO_16_9);
    var widgetMaxHeight = windowHeight - HEADER_HEIGHT - PADDING_BOTTOM;
    var defaultVisualizationHeight = constants_1.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT_PX - HEADLINE_OUTER_HEIGHT;
    var maxHeight = widgetMaxHeight > defaultVisualizationHeight ? widgetMaxHeight : defaultVisualizationHeight;
    return {
        height: widgetHeight,
        maxHeight: maxHeight,
    };
}
exports.calculateGeoPushpinWidgetHeight = calculateGeoPushpinWidgetHeight;
function isGeoPushpin(visType) {
    return visType === constants_2.DASHBOARD_LAYOUT_VIS_TYPE.pushpin;
}
exports.isGeoPushpin = isGeoPushpin;
function isFullWidthGeoPushpin(currentColumnWidth, visType) {
    return isGeoPushpin(visType) && currentColumnWidth === constants_2.DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT;
}
exports.isFullWidthGeoPushpin = isFullWidthGeoPushpin;
function getGeoPushpinWidgetStyle(visType, visualizationItemWidth, currentColumnWidth, windowHeight, enableCustomHeight) {
    if (isFullWidthGeoPushpin(currentColumnWidth, visType) && !enableCustomHeight) {
        var _a = calculateGeoPushpinWidgetHeight(windowHeight, visualizationItemWidth), height = _a.height, maxHeight = _a.maxHeight;
        return {
            height: height,
            maxHeight: maxHeight,
        };
    }
    return null;
}
exports.getGeoPushpinWidgetStyle = getGeoPushpinWidgetStyle;
//# sourceMappingURL=legacy.js.map